import {Dialog, DialogBody, DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledEventFormDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing * 4.5}px ${spacing * 6}px;
    `
)

export const StyledEventFormDialog = styled(Dialog)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
`

export const StyledEventFormDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)
